let state = {
	apiHost: process.env.VUE_APP_API_URL,
	orderPlatformHost: process.env.VUE_APP_ORDERPLATFORM_URL,
	appUrl: process.env.VUE_APP_APP_URL,
	diamondStockUrl: process.env.VUE_APP_DIAMONDSTOCK_URL,
	integrationUriPrafrix: '',
	visualMode: 'show',
	currentVarType: '',
	lastCurrentVarType: '',
	country: 'de',
	language: 'de',
	shopId: 0,
	website: '',
}

let actions = {
	setIntegrationUrlPrafix(context, urlPrafxi) {
		context.commit('setIntegrationUrlPrafix', urlPrafxi);
	},
	setCountry(context, country) {
	if (country.length === 2) {
		context.commit('setCountry', country);
	}
	},
	setLanguage(context, language) {
		if (language.length === 2) {
			context.commit('setLanguage', language);
		}
	},
	setWebsite(context, website) {
		website = website.trim();
		if (website !== '') {
			context.commit('setWebsite', website);
		}
	},
	setCurrentVarType(context, varType) {
		if (typeof varType === 'string' && varType !== "") {
			context.commit("setCurrentVarType", varType);
			context.commit('setVisualMode', 'conf');
		}
	},
	setShopId(context, shopId) {
		if (typeof shopId === 'number' && shopId > 10000) {
			context.commit("setShopId", shopId)
		} else {
			context.commit("setShopId", 0)
		}
	}
}

let mutations = {
	setIntegrationUrlPrafix(state, urlPrafix) {
		if (urlPrafix.substring(-1, 1) === '/') {
			urlPrafix = urlPrafix.slice(0, -1);
		}
		state.integrationUriPrafrix = urlPrafix;
	},
	setCountry(state, country) {
		state.country = country;
	},
	setLanguage(state, language) {
		state.language = language;
	},
	setCurrentVarType(state, varType) {
		state.currentVarType = varType;
		if (varType !== "") {
			state.lastCurrentVarType = varType
		}
	},
	setShopId(state, shopId) {
		state.shopId = shopId
	}
}

let getters =  {
	getApiHostWithLocalStr: state => {
		let host = state.apiHost;

		if (state.country + "-" + state.language !== 'de-de') {
			host += "/" + state.country + "-" + state.language;
		}

		return host;
	},
	getApiHost: state => {
		return state.apiHost;
	},
	getOrderPlatformHost: state => {
		return state.orderPlatformHost
	},
	getAppUrl: state => {
		return state.appUrl;
	},
	getDiamondStockUrl: state => {
		return state.diamondStockUrl;
	},
	getIntegrationUrlPrafix: state => {
		return state.integrationUriPrafrix;
	},
	getConfig: state => {
		return state;
	},
	getLocalStr: state => {
		return state.country + "-" + state.language;
	},
	getCountry: state => {
		return state.country;
	},
	getLanguage: state => {
		return state.language;
	},
	getCurrentVarType: state => {
		return state.currentVarType;
	},
	getLastCurrentVarType: state => {
		return state.lastCurrentVarType;
	},
	getActiveShop: state => {
		return state.shopId
	},
	isShopLoginActive: state => {
		return (state.shopId > 10000)
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}

